import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CACHE_KEY = "operating_flags_v1";
const CACHE_TTL_MS = 60_000; // 60s — short so toggles propagate fast in demos

const DEFAULTS = {
  online_booking_enabled: false,
  salon_phone_e164: "+19726913618",
  salon_phone_display: "(972) 691-3618",
  ready: false,
};

function readCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { data, t } = JSON.parse(raw);
    if (!data || !t || Date.now() - t > CACHE_TTL_MS) return null;
    return data;
  } catch {
    return null;
  }
}

/**
 * Returns { online_booking_enabled, salon_phone_e164, salon_phone_display, ready }.
 * Every customer-facing CTA in the app consults this hook so the whole site
 * flips between "call us" mode and "book online" mode from a single toggle.
 */
export default function useOperatingFlags() {
  const [flags, setFlags] = useState(() => {
    const cached = readCache();
    return cached ? { ...DEFAULTS, ...cached, ready: true } : DEFAULTS;
  });

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND_URL}/api/feature-flags/public`)
      .then((r) => r.json())
      .then((data) => {
        if (cancelled || !data) return;
        const next = {
          online_booking_enabled: !!data.online_booking_enabled,
          salon_phone_e164: data.salon_phone_e164 || DEFAULTS.salon_phone_e164,
          salon_phone_display: data.salon_phone_display || DEFAULTS.salon_phone_display,
        };
        setFlags({ ...next, ready: true });
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data: next, t: Date.now() }));
        } catch {}
      })
      .catch(() => {
        if (!cancelled) setFlags((f) => ({ ...f, ready: true }));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return flags;
}
